import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router-dom';
import { AppCard, AppPageHeader } from '../../components';
import { SymbolsTable } from '../../components/Admin';
import SymbolMatrixTab from './SymbolMatrixTab';

type SymbolsTab = 'symbols' | 'matrix';

export default function SymbolsPage() {
	const [searchParams, setSearchParams] = useSearchParams();
	const activeTab: SymbolsTab = searchParams.get('tab') === 'matrix' ? 'matrix' : 'symbols';

	const handleTabChange = (_event: React.SyntheticEvent, nextTab: SymbolsTab) => {
		const nextParams = new URLSearchParams(searchParams);
		if (nextTab === 'matrix') {
			nextParams.set('tab', 'matrix');
		} else {
			nextParams.delete('tab');
		}
		setSearchParams(nextParams);
	};

	return (
		<>
			<AppPageHeader>
				<Typography variant="h6">Symbols</Typography>
				<Typography variant="body2" color="text.secondary">
					{activeTab === 'symbols'
						? 'Browse dataset symbols and their company mappings.'
						: 'Compare company symbol mappings across datasets.'}
				</Typography>
				<Tabs
					value={activeTab}
					onChange={handleTabChange}
					aria-label="Symbol administration views"
					sx={{ mt: 1.5, minHeight: 36 }}
				>
					<Tab
						id="symbols-tab"
						aria-controls="symbols-panel"
						label="Symbols"
						value="symbols"
						sx={{ minHeight: 36, py: 0 }}
					/>
					<Tab
						id="matrix-tab"
						aria-controls="matrix-panel"
						label="Matrix"
						value="matrix"
						sx={{ minHeight: 36, py: 0 }}
					/>
				</Tabs>
			</AppPageHeader>
			<Box
				id={`${activeTab}-panel`}
				role="tabpanel"
				aria-labelledby={`${activeTab}-tab`}
			>
				{activeTab === 'symbols' ? (
					<AppCard>
						<SymbolsTable />
					</AppCard>
				) : (
					<SymbolMatrixTab />
				)}
			</Box>
		</>
	);
}
